import React from "react";
import { 
  BarChart,
  Bar, 
  XAxis, 
  YAxis, 
  CartesianGrid, 
  Tooltip, 
  Legend, 
  ResponsiveContainer 
} from 'recharts';

export default function DayCapStackedBarChart(props) {
  const { dayCapData, unit } = props;
  
  // If no data or empty data, return null
  if (!dayCapData || dayCapData.length === 0) {
    return <div>No data available for stacked bar chart</div>;
  }

  // Process the data to create a format suitable for stacked bar chart
  // Each entry should have: date and values for each inverter
  const processedData = dayCapData.map(item => {
    const entry = { date: item.date };
    
    // Add each inverter's day_cap value to the entry
    if (item.day_cap && typeof item.day_cap === 'object') {
      for (const [inverter, value] of Object.entries(item.day_cap)) {
        entry[inverter] = parseFloat(value) || 0;
      }
    }
    
    return entry;
  });

  // Get all unique inverters from the data
  const inverters = new Set();
  dayCapData.forEach(item => {
    if (item.day_cap && typeof item.day_cap === 'object') {
      Object.keys(item.day_cap).forEach(key => inverters.add(key));
    }
  });
  
  const inverterList = Array.from(inverters);

  const inverterColors = [
    "#1976D2", "#1E88E5", "#2196F3", "#42A5F5", "#64B5F6", 
    "#E3F2FD", "#BBDEFB", "#90CAF9", "#1565C0", "#0D47A1",
  ];

  return (
    <div style={{ height: '400px' }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={processedData}
          margin={{
            top: 5,
            right: 55,
            left: 45,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis unit={unit} />
          <Tooltip />
          <Legend />
          {inverterList.map((inverter, index) => (
            <Bar 
              key={inverter} 
              dataKey={inverter} 
              stackId="a" 
              fill={inverterColors[index % inverterColors.length]} 
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
